import { getBrandValue } from '~/shared/utils/brandNameHelper';

export const SizeTypes = {
  BOTTOM_SIZE: 'bottomSize',
  TOP_SIZE: 'topSize',
  BRA_SIZE: 'braSize',
  CUP_SIZE: 'cupSize',
  LINGERIE_SIZE: 'lingerieSize',
  BAND_SIZE: 'bandSize',
  BRALETTE_SIZE: 'braletteSize',
};

export const apparelOptionsWomens = getBrandValue({
  savage: new Set([
    SizeTypes.BAND_SIZE,
    SizeTypes.CUP_SIZE,
    SizeTypes.BOTTOM_SIZE,
    SizeTypes.LINGERIE_SIZE,
  ]),
  default: new Set([
    SizeTypes.BOTTOM_SIZE,
    SizeTypes.BRA_SIZE,
    SizeTypes.TOP_SIZE,
  ]),
});

export const apparelOptionsMens = getBrandValue({
  savage: new Set([SizeTypes.BOTTOM_SIZE]),
  default: new Set([
    SizeTypes.BOTTOM_SIZE,
    SizeTypes.BRA_SIZE,
    SizeTypes.TOP_SIZE,
  ]),
});
